@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.Tooltip {
  @extend %font-family-primary;

  font-size: $font-size-normal;
  z-index: 10000;
  white-space: pre-wrap;
  word-break: break-word;
  margin-right: 2px;

  &.white {
    background: $theme-color-secondary-button-background;
    color: $theme-color-text;
    box-shadow: 0 4px 16px $color-dropdown-box-shadow;
    border: 1px solid $theme-color-dropdown-border-color;
    border-radius: 8px;
    padding: 16px;
  }

  &.black {
    background: $theme-color-tooltip;
    color: $color-white;
    box-shadow: none;
    border: none;
    border-radius: 4px;
    padding: 6px 8px;
  }
}
